export const contactData = {
  info: {
    title: "Contact Information",
    description: "Say something to start a live chat!",
    details: {
      phone: {
        label: "Phone",
        value: "+201557757721",
        link: "tel:+201557757721",
      },
      email: {
        label: "Email",
        value: "hr@dolophin.com",
        link: "mailto:hr@dolophin.com",
      },
      address: {
        label: "Address",
        value:
          "Tanta, El Bahr Street – in front of Tanta Hospital above Almokhtabar Lab",
      },
    },
    social: {
      facebook: "#",
      linkedin: "#",
    },
  },

  form: {
    fields: {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone Number",
      message: "Message",
    },
    cta: "Send message",
  },
};